<template>
	<div>
		<base-dialog v-model="showDisclaimerDialog" :dontShowAgainCookie="FOODS_DISCLAIMER_COOKIE_NAME" :cancelFn="() => { $router.go(-1) }">
			<p v-html="$t('foods.disclaimer')"></p>
		</base-dialog>
		<MicrohabitCategoriesPanelMenu :type="MICROHABIT_FOOD_TYPE"/>
	</div>
</template>

<script>
import MicrohabitCategoriesPanelMenu from '@/components/microhabits/MicrohabitCategoriesPanelMenu'
import { MICROHABIT_FOOD_TYPE } from '@/constants/microhabitTypes'
import { FOODS_DISCLAIMER_COOKIE_NAME } from '@/constants/cookies'
import BaseDialog from '@/components/base/BaseDialog'

export default {
	components: {
		MicrohabitCategoriesPanelMenu,
		BaseDialog
	},
	data () {
		return {
			FOODS_DISCLAIMER_COOKIE_NAME,
			MICROHABIT_FOOD_TYPE,
			showDisclaimerDialog: true
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/webapp/patient/foods/FoodCategoriesPanelMenu.vue